import { Navbar } from "./components/navbar/Navbar.jsx";
import { Banner } from "./components/Banner.jsx";
import { useEffect, useState } from "react";

export function Main({ page, donateButton }) {
  const [user, setUser] = useState(undefined);
  const [dialog, setDialog] = useState(null);
  const [donates, setDonates] = useState(null);

  useEffect(() => {
    if (dialog) {
      document.getElementsByTagName("body")[0].classList.add("modal-open");
    } else {
      document.getElementsByTagName("body")[0].classList.remove("modal-open");
    }

    for (let element of document.getElementsByTagName("dialog")) {
      if (element.id === "error-dialog") {
        element.style.zIndex = 100;
        continue;
      }

      element.style.zIndex = 10000;
      element.showModal();

      element.addEventListener("click", (e) => {
        let rect = element.getBoundingClientRect();
        let isInDialog =
          rect.top <= e.clientY &&
          e.clientY <= rect.top + rect.height &&
          rect.left <= e.clientX &&
          e.clientX <= rect.left + rect.width;
        if (!isInDialog && e.target.tagName !== "INPUT") {
          element.close();
        }
      });
    }
  }, [dialog]);

  useEffect(() => {
    let body = document.querySelector("body");
    let lock = dialog !== null;
    if (lock) {
      body.style.height = '100%';
      body.style.overflow = 'hidden';
    } else {
      body.style.removeProperty("height");
      body.style.removeProperty("overflow");
    }
  }, [dialog]);

  return (
    <>
      <header>
        <Navbar user={user} setDialog={setDialog} donateButton={donateButton} />
      </header>
      <main>
        <Banner />
        {page({ donates, setDonates, setDialog })}
        {dialog && dialog}
      </main>
      <footer>
        <h3>Сервер не связан с Mojang или Microsoft</h3>
        <h3><u><a style={{"color": "#B3B7BC"}} href="/offer">Оферта магазина</a></u></h3>
        <h3>Обратная связь: <a style={{"color": "#B3B7BC"}} href="mailto:support@kachanovcraft.com"><u>support@kachanovcraft.com</u></a></h3>
      </footer>
    </>
  );
}
